// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { formatDateToShort } from "../../../utils/utilities";

// import {
//   APP_DEV_URL,
//   APP_BASE_URL,
//   VAVE,
//   GETSAVEIDEABYEMPID,
// } from "../../../Pages/AppConstant";

// const getStatusColor = (status) => {
//   switch (status) {
//     case "approved":
//       return "green";
//     case "rejected":
//       return "red";
//     case "pending":
//       return "orange";
//     case "inprogress":
//       return "orange";
//     default:
//       return "gray";
//   }
// };

// // Card component
// const RequestCard = ({ topic, date, model, varient, subVarient, status }) => {
//   const statusColor = getStatusColor(status);

//   return (
//     <div className="card mb-4">
//       <div className="card-body">
//         <h5 className="card-title">Your Idea: {topic}</h5>
//         {/* <div className="row">
//           <div className="row">
//             <div className="col-md-4"> */}
//         <h6 className="card-title">Model: {model}</h6>
//         {/* </div> */}
//         {/* <div className="col-md-4">
//               <h6 className="card-title">Variant: {varient}</h6>
//             </div> */}
//         {/* <div className="col-md-4">
//               <h6 className="card-title">Sub-Variant: {subVarient}</h6>
//             </div> */}
//         {/* </div>
//         </div> */}
//         <p className="card-text">Date: {date}</p>
//         <p className="card-text">
//           Status:{" "}
//           <span style={{ color: statusColor, fontWeight: "bold" }}>
//             {status}
//           </span>
//         </p>
//       </div>
//     </div>
//   );
// };

// // Grid list component
// function RequestList() {
//   const [ideaListByEmpId, setIdeaListByEmpId] = useState([]);

//   const [createdDate, setCreatedDate] = useState("");
//   useEffect(() => {
//     fetchAllData();
//   }, []);
//   const fetchAllData = () => {
//     axios({
//       method: "get",
//       url: VAVE + GETSAVEIDEABYEMPID + localStorage.getItem("empid"),
//       withCredentials: false,
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded",
//       },
//     })
//       .then((res) => {
//         console.log("API response:", res.data);
//         setIdeaListByEmpId(res.data.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching categories:", error);
//       });
//   };



//   return (
//     <div className="container mt-8">
//       <div className="table-responsive">
//         <table className="table table-bordered table-striped custom-table">
//           <thead className="thead-dark">
//             <tr>
//               <th>S.No</th>
//               {/* <th>Actions</th> */}
//               <th>Status</th>
//               <th> Idea Category </th>

//               <th> Part No </th>
//               {/* <th>Description</th> */}
//               <th>Proposed Idea</th>
//               {/* <th>Current Condition</th> */}
//               <th>Savings</th>
//               {/* <th>Aggregate</th> */}
//               {/* <th>Model</th> */}
//               {/* <th>Variant</th> */}

//               <th>Sub Variant</th>
//               {/* <th>Domain</th>
//               <th>Function</th>
//               <th>Location</th> */}
//               {/* <th>Document</th> */}
//               <th>View More</th>
//             </tr>
//           </thead>
//           <tbody>
//             {ideaListByEmpId.map((req, index) => (
//               <tr key={req.id}>
//                 <td>{index + 1}</td>
//                 {/* <td>
//                   {role === "Admin" ? (
//                     <Button
//                       variant="text"
//                       title="Edit"
//                       onClick={() => handleEdit(req)}
//                     >
//                       {req.ideaCategory}
//                     </Button>
//                   ) :
//                     <Button
//                       variant="text"
//                       title="View"
//                       onClick={() => handleView(req)}
//                     >
//                       {req.ideaCategory}
//                     </Button>
//                   }
//                 </td> */}
//                 <td style={{ color: getStatusColor(req.status) }}>
//                   {req.status}
//                 </td>
//                 <td>{req.idea_category}</td>

//                 <td>{req.partno}</td>
//                 {/* <td>{req.part_description}</td> */}
//                 <td>{req.proposed_idea}</td>
//                 {/* <td>{req.current_condition}</td> */}
//                 <td>{req.benefit}</td>
//                 <td>{req.idea_effective}</td>
//                 {/* <td>{req.subvarient}</td> */}
//                 {/* <td>{req.model}</td>
//                 <td>{req.varient}</td>
//                 <td>{req.domain}</td>
//                 <td>{req.function}</td>
//                 <td>{req.location}</td> */}
//                 {/* <td>
//                   {req.filepath ? (
//                     <a href={req.filepath} target="_blank" rel="noreferrer">
//                       View File
//                     </a>
//                   ) : (
//                     "No File"
//                   )}
//                 </td> */}
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

// export default RequestList;

// // import React, { useState, useEffect } from "react";
// // import axios from "axios";
// // import {
// //   APP_DEV_URL,
// //   VAVE,
// //   GETSAVEIDEABYEMPID,
// // } from "../../../Pages/AppConstant";
// // import { Pagination, Stack } from "@mui/material";

// // // Utility to color status
// // const getStatusColor = (status) => {
// //   switch (status?.toLowerCase()) {
// //     case "approved":
// //       return "green";
// //     case "rejected":
// //       return "red";
// //     case "pending":
// //       return "orange";
// //     default:
// //       return "gray";
// //   }
// // };

// // function RequestList() {
// //   const [ideaListByEmpId, setIdeaListByEmpId] = useState([]);
// //   const [currentPage, setCurrentPage] = useState(1);
// //   const itemsPerPage = 10;

// // useEffect(() => {
// //   fetchAllData();
// // }, []);

// // const fetchAllData = () => {
// //   const empId = localStorage.getItem("empid");

// //   axios({
// //     method: "get",
// //     url: APP_DEV_URL + VAVE + GETSAVEIDEABYEMPID + empId,
// //     withCredentials: false,
// //     headers: {
// //       "Content-Type": "application/x-www-form-urlencoded",
// //     },
// //   })
// //     .then((res) => {
// //       console.log("API response:", res.data);
// //       setIdeaListByEmpId(res.data.data || []);
// //     })
// //     .catch((error) => {
// //       console.error("Error fetching ideas:", error);
// //     });
// // };

// // // Pagination logic
// // const paginatedIdeas = ideaListByEmpId.slice(
// //   (currentPage - 1) * itemsPerPage,
// //   currentPage * itemsPerPage
// // );

// // const totalPages = Math.ceil(ideaListByEmpId.length / itemsPerPage);

// //   return (
// //     <div className="container mt-4">
// //       <div className="table-responsive">
// //         <table className="table table-bordered table-striped custom-table">
// //           <thead className="thead-dark">
// //             <tr>
              // <th>S.No</th>
              // <th>Status</th>
              // <th>Idea Category</th>
              // <th>Part No</th>
              // <th>Description</th>
              // <th>Proposed Idea</th>
              // <th>Current Condition</th>
              // <th>Savings</th>
              // <th>Aggregate</th>
              // <th>Model</th>
              // <th>Variant</th>
              // <th>Domain</th>
              // <th>Function</th>
              // <th>Location</th>
              // <th>Document</th>
// //             </tr>
// //           </thead>
// //           <tbody>
// //             {paginatedIdeas.map((req, index) => (
// //               <tr key={req.id}>
// //                 <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
// //                 <td style={{ color: getStatusColor(req.status) }}>
// //                   {req.status}
// //                 </td>
// //                 <td>{req.idea_category}</td>
// //                 <td>{req.partno}</td>
// //                 <td>{req.part_description}</td>
// //                 <td>{req.proposed_idea}</td>
// //                 <td>{req.current_condition}</td>
// //                 <td>{req.benefit}</td>
// //                 <td>{req.idea_effective}</td>
// //                 <td>{req.model}</td>
// //                 <td>{req.varient}</td>
// //                 <td>{req.domain}</td>
// //                 <td>{req.function}</td>
// //                 <td>{req.location}</td>
// //                 <td>
// //                   {req.filepath ? (
// //                     <a href={req.filepath} target="_blank" rel="noreferrer">
// //                       View File
// //                     </a>
// //                   ) : (
// //                     "No File"
// //                   )}
// //                 </td>
// //               </tr>
// //             ))}
// //           </tbody>
// //         </table>
// //       </div>

// //       {/* Material-UI Pagination */}

// // <Stack spacing={2} alignItems="center" marginTop={4} color="white">
// //   <Pagination

// //     count={totalPages}
// //     page={currentPage}
// //     onChange={(event, value) => setCurrentPage(value)}
// //     color="primary"
// //     variant="outlined"
// //     shape="rounded"
// //   />
// // </Stack>

// //     </div>
// //   );
// // }

// // export default RequestList;



// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { formatDateToShort } from "../../../utils/utilities";
// import {
//   APP_DEV_URL,
//   APP_BASE_URL,
//   VAVE,
//   GETSAVEIDEABYEMPID,
// } from "../../../Pages/AppConstant";
// import Dialog from "@mui/material/Dialog";
// import DialogTitle from "@mui/material/DialogTitle";
// import DialogContent from "@mui/material/DialogContent";
// import DialogActions from "@mui/material/DialogActions";
// import Button from "@mui/material/Button";
// import AutorenewIcon from "@mui/icons-material/Autorenew";

// const getStatusColor = (status) => {
//   switch (status) {
//     case "approved":
//       return "green";
//     case "rejected":
//       return "red";
//     case "pending":
//       return "orange";
//     case "inprogress":
//       return "orange";
//     default:
//       return "gray";
//   }
// };

// // Grid list component
// function RequestList() {
//   const [ideaListByEmpId, setIdeaListByEmpId] = useState([]);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [selectedIdea, setSelectedIdea] = useState(null);

//   useEffect(() => {
//     fetchAllData();
//   }, []);

//   const fetchAllData = () => {
//     axios({
//       method: "get",
//       url: VAVE + GETSAVEIDEABYEMPID + localStorage.getItem("empid"),
//       withCredentials: false,
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded",
//       },
//     })
//       .then((res) => {
//         console.log("API response:", res.data);
//         setIdeaListByEmpId(res.data.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching categories:", error);
//       });
//   };

//   const handleViewMore = (idea) => {
//     setSelectedIdea(idea);
//     setOpenDialog(true);
//   };

//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//     setSelectedIdea(null);
//   };

//   return (
//     <div className="container mt-8">
//       <div className="table-responsive">
//         <table className="table table-bordered table-striped custom-table">
//           <thead className="thead-dark">
//             <tr>
//               <th>S.No</th>
//               <th>Status</th>
//               <th>Idea Category</th>
//               <th>Part No</th>
//               <th>Proposed Idea</th>
//               <th>Savings</th>
//               <th>Sub Variant</th>
//               <th>View More</th>
//             </tr>
//           </thead>
//           <tbody>
//             {ideaListByEmpId.map((req, index) => (
//               <tr key={req.id}>
//                 <td>{index + 1}</td>
//                 <td style={{ color: getStatusColor(req.status) }}>
//                   {req.status}
//                 </td>
//                 <td>{req.idea_category}</td>
//                 <td>{req.partno}</td>
//                 <td>{req.proposed_idea}</td>
//                 <td>{req.benefit}</td>
//                 <td>{req.idea_effective}</td>
//                 <td
//                   style={{ cursor: "pointer" }}
//                   onClick={() => handleViewMore(req)}
//                 >
//                   <AutorenewIcon />
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* Dialog for View More */}
//       <Dialog open={openDialog} onClose={handleCloseDialog}>
//         <DialogTitle>Idea Details</DialogTitle>
//         <DialogContent>
//           {selectedIdea && (
//             <div>
//               <p>
//                 <strong>S.No:</strong> {ideaListByEmpId.indexOf(selectedIdea) + 1}
//               </p>
//               <p>
//                 <strong>Status:</strong>{" "}
//                 <span style={{ color: getStatusColor(selectedIdea.status) }}>
//                   {selectedIdea.status}
//                 </span>
//               </p>
//               <p>
//                 <strong>Idea Category:</strong> {selectedIdea.idea_category}
//               </p>
//               <p>
//                 <strong>Part No:</strong> {selectedIdea.partno}
//               </p>
//               <p>
//                 <strong>Proposed Idea:</strong> {selectedIdea.proposed_idea}
//               </p>
//               <p>
//                 <strong>Savings:</strong> {selectedIdea.benefit}
//               </p>
//               <p>
//                 <strong>Sub Variant:</strong> {selectedIdea.idea_effective}
//               </p>
//             </div>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseDialog} color="primary">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// }

// export default RequestList;


import React, { useState, useEffect } from "react";
import axios from "axios";
import { formatDateToShort } from "../../../utils/utilities";
import {
  APP_DEV_URL,
  APP_BASE_URL,
  VAVE,
  DOWNLOADUPLOADEDUSERFILE,
  GETSAVEIDEABYEMPID,
} from "../../../Pages/AppConstant";

import { Pagination, Stack } from "@mui/material";
import loadergif from "../../../assets/images/BG-switch loader_2.gif";


import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const getStatusColor = (status) => {
  switch (status) {
    case "approved":
      return "green";
    case "rejected":
      return "red";
    case "pending":
      return "orange";
    case "inprogress":
      return "orange";
    default:
      return "gray";
  }
};

function RequestList() {
  const [ideaListByEmpId, setIdeaListByEmpId] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedIdea, setSelectedIdea] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const itemsPerPage = 10;
  const totalPages = Math.ceil(ideaListByEmpId.length / itemsPerPage);
 
  const [isloading, setIsloading] = useState(false);



  useEffect(() => {
    fetchAllData();
  }, []);

  const fetchAllData = () => {
    axios({
      method: "get",
      url: VAVE + GETSAVEIDEABYEMPID + localStorage.getItem("empid"),
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((res) => {
        console.log("API response:", res.data);
        setIdeaListByEmpId(res.data.data);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  };


    const filteredIdeas = ideaListByEmpId.filter((item) => {
    const query = searchQuery.toLowerCase();
    const matchesSearch = Object.values(item).some((value) =>
      String(value).toLowerCase().includes(query)
    );
    // const matchesFilter =
    //   selectedFilter === "All" ||
    //   item.status?.toLowerCase() === selectedFilter.toLowerCase();
    return matchesSearch;
    // && matchesFilter;
  });
  const paginatedIdeas = filteredIdeas.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleViewMore = (idea) => {
    setSelectedIdea(idea);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedIdea(null);
  };


  const isIdeaUpdatedToday = (idea) => {
    if (!idea?.url_2b2_created_timestamp) return false;

    const updatedDate = new Date(idea.url_2b2_created_timestamp)
      .toISOString()
      .split("T")[0];

    return updatedDate === "2025-11-20";
  };

    const downloadUploadedUserDocApi = (request) => {
    setIsloading(true);
    axios({
      method: "post",
      url: VAVE + DOWNLOADUPLOADEDUSERFILE,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: { idea_id: request.id },
      responseType: "blob", 
    })
      .then((response) => {
        if (response.data.size === 14) {
          alert("No Data Available");
          setIsloading(false);
          return;
        }

        const contentType =
          response.headers["content-type"] || "application/pdf";
        const disposition = response.headers["content-disposition"];
        let filename = `Idea_${request.idea_unique_id}_User_Document.pdf`;


        const blob = new Blob([response.data], { type: contentType });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up
        URL.revokeObjectURL(url);
        setIsloading(false);
      })
      .catch((error) => {
        window.open(selectedIdea.filepath, "_blank");
        setIsloading(false);
      });
  };
  return (
    <div className="container mt-2">

  {isloading ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div className="loadergif">
            <img src={loadergif} alt="Loading..." />
          </div>
        </div>
      ) : (
        ""
      )}

    <div className="container mt-8">
      <div className="table-responsive">
        <table className="table table-bordered table-striped custom-table">
          <thead className="thead-dark">
            <tr>
              <th>SW Id</th>
              <th>Status</th>
              <th>Idea Category</th>
              <th>Part No</th>
              {/* <th>Description</th> */}
              {/* <th>Proposed Idea</th> */}
              {/* <th>Current Condition</th> */}
              <th>Savings</th>
              <th>Aggregate</th>
              <th>Sub Variant</th>
              {/* <th>Model</th>
              <th>Variant</th>
              <th>Domain</th>
              <th>Function</th>
              <th>Location</th>
              <th>Document</th> */}
              <th>View More</th>
            </tr>
          </thead>
          <tbody>
            
         {paginatedIdeas.length === 0 ? (
              <tr>
                <td colSpan="8" className="text-center py-4">
                  No ideas found
                </td>
              </tr>
            ) : (
            
            paginatedIdeas.map((req, index) => (
              <tr key={req.id}>
                <td>{req.idea_unique_id}</td>
                <td style={{ color: getStatusColor(req.status) }}>
                  {req.status}
                </td>
                <td>{req.idea_category}</td>
                <td>{req.partno}</td>
                {/* <td>{req.part_description}</td> */}
                {/* <td>{req.proposed_idea}</td> */}
                {/* <td>{req.current_condition}</td> */}
                <td>{req.benefit}</td>
                <td>{req.idea_effective}</td>
                {/* <td>{req.model}</td>
                <td>{req.varient}</td> */}
                <td>{req.subvarient}</td>
                {/* <td>{req.domain}</td>
                <td>{req.function}</td>
                <td>{req.location}</td>
                <td>
                  {req.filepath ? (
                    <a href={req.filepath} target="_blank" rel="noreferrer">
                      View File
                    </a>
                  ) : (
                    "No File"
                  )}
                </td> */}
                <td
                  style={{ cursor: "pointer" }}
                  onClick={() => handleViewMore(req)}
                >
                  <FormatListBulletedIcon />
                </td>
              </tr>
            )))}
          </tbody>
        </table>
      </div>

      {/* Dialog for View More */}
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        <DialogTitle>Idea Details</DialogTitle>
        <DialogContent>
          {selectedIdea && (
            <Grid container spacing={2}>
              {/* Left Column */}
              <Grid item xs={12} sm={6}>
                {/* <Typography variant="body1">
                  <strong>S.No:</strong> {ideaListByEmpId.indexOf(selectedIdea) + 1}
                </Typography> */}
                <Typography variant="body1">
                  <strong>Status:</strong>{" "}
                  <span style={{ color: getStatusColor(selectedIdea.status) }}>
                    {selectedIdea.status}
                  </span>
                </Typography>
                <Typography variant="body1">
                  <strong>Idea Category:</strong> {selectedIdea.idea_category}
                </Typography>
                <Typography variant="body1">
                  <strong>Part No:</strong> {selectedIdea.partno}
                </Typography>
                <Typography variant="body1">
                  <strong>Description:</strong> {selectedIdea.part_description}
                </Typography>
                <Typography variant="body1">
                  <strong>Proposed Idea:</strong> {selectedIdea.proposed_idea}
                </Typography>
                <Typography variant="body1">
                  <strong>Current Condition:</strong> {selectedIdea.current_condition}
                </Typography>
                  <Typography variant="body1">
                  <strong>Savings:</strong> {selectedIdea.benefit}
                </Typography>
              </Grid>
              {/* Right Column */}
              <Grid item xs={12} sm={6}>
              
                <Typography variant="body1">
                  <strong>Aggregate:</strong> {selectedIdea.idea_effective}
                </Typography>
                <Typography variant="body1">
                  <strong>Model:</strong> {selectedIdea.model}
                </Typography>
                <Typography variant="body1">
                  <strong>Variant:</strong> {selectedIdea.varient}
                </Typography>
                  <Typography variant="body1">
                                  <strong>Sub Variant:</strong> {selectedIdea.subvarient}
                                </Typography>
                <Typography variant="body1">
                  <strong>Domain:</strong> {selectedIdea.domain}
                </Typography>
                <Typography variant="body1">
                  <strong>Function:</strong> {selectedIdea.function}
                </Typography>
                <Typography variant="body1">
                  <strong>Location:</strong> {selectedIdea.location}
                </Typography>
                {/* <Typography variant="body1">
                  <strong>Document:</strong>{" "}
                  {selectedIdea.filepath ? (
                  

                       <button
                        onClick={() => downloadUploadedUserDocApi(selectedIdea)}
                      >
                        Download File
                      </button>
                     
                  
                  ) : (
                    "No File"
                  )}
                </Typography> */}
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>



       <Stack alignItems="center" marginTop={1} color="white">
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(event, value) => setCurrentPage(value)}
          color="primary"
          variant="outlined"
          shape="circular"
          sx={{
            "& .MuiPaginationItem-root": {
              color: "black",
              borderColor: "black",
              backgroundColor: "white",
            },
            "& .Mui-selected": {
              backgroundColor: "green",
              color: "white",
            },
          }}
        />
      </Stack>
    </div>
    </div>
  );
}

export default RequestList;